import React, {FC, RefObject, useEffect, useRef, useState} from "react";
import {useRouter} from "next/router";
import {useSelector} from "react-redux";
import cls from "./category.module.scss";
import {IState} from "../../../types/state";
import {ArrowRoundedDown12x7Svg} from "../../../svg";
import {TranslationsType} from "../../../types/homePageTypes";
import {IAtributeOptions, IAttributeValue} from "../../../types/widgetFiltresTypes";

interface IFilterCheckProps {
    title: string
    value: IAttributeValue,
    data: Array<IAtributeOptions>,
    translationsData: TranslationsType
}

const CustomFilterSelect: FC<IFilterCheckProps> = ({data = [], value, title, translationsData}) => {
    const {attributes: [{code = ""} = {}] = []} = value || {};
    const sidebarOpen = useSelector((state: IState) => state.sidebar.open);
    const [filterListHeight, setFilterListHeight] = useState<boolean>(false);
    const checkRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
    const router = useRouter();
    const isOpen = (router.query?.open_dd as string)?.split(",")?.includes(title) || false;
    const selectedId = String(router.query?.[`filter_${code}`] || "");
    const selectedItem = data.find(item => String(item.id) === selectedId);

    useEffect(() => {
        if (!filterListHeight && checkRef.current?.clientHeight) {
            setFilterListHeight(checkRef.current?.clientHeight > 88);
        }
    }, [checkRef.current?.clientHeight, sidebarOpen]);

    const toggleOpen = async () => {
        const currentOpen = (router.query?.open_dd as string)?.split(",") || [];
        let updated = currentOpen.includes(title)
            ? currentOpen.filter(item => item !== title)
            : [...currentOpen, title];

        if (updated.length === 0) {
            const {open_dd, ...rest} = router.query;
            await router.push({query: rest}, undefined, {scroll: false});
        } else {
            await router.push({...router, query: {...router.query, open_dd: updated.join(",")}}, undefined, {scroll: false});
        }
    };

    const handleSelect = async (id: string) => {
        const currentOpen = (router.query?.open_dd as string)?.split(",") || [];
        const updated = currentOpen.filter(item => item !== title);

        const newQuery = {
            ...router.query,
            [`filter_${code}`]: id
        };

        if (router.query[`filter_${code}`] === `${id}`) {
            delete newQuery[`filter_${code}`]
        }

        if (updated.length === 0) {
            delete newQuery.open_dd;
        } else {
            newQuery.open_dd = updated.join(",");
        }

        await router.push({query: newQuery}, undefined, {scroll: false});
    };

    return (
        <div className={`${cls["filter-list"]} ${!isOpen && filterListHeight ? cls["filter-list__closed"] : ""}`} ref={checkRef}>
            <div className={`${cls.widget__title} ${cls.select__title}`}>{title}</div>
            <div className={`${cls.widget__field} ${cls.select__filter}`} onClick={toggleOpen}>
                {!selectedItem ?
                    <div className={cls["placeholder"]}>{translationsData.ChooseOption}</div>
                    :
                    <div className={cls["selected__item"]}>{selectedItem.label}</div>
                }
                {data.length > 0 && (
                    <button
                        className={`${cls.filter__item} ${isOpen && cls.open}`}
                        type="button"
                    >
                        <ArrowRoundedDown12x7Svg className={cls["mobile-links__item-arrow"]}/>
                    </button>
                )}
            </div>
            {isOpen && (
                <div className={`${cls["filter-select__list"]} ${cls.select_filter__options}`}>
                    {data.map((item, index) => (
                        <div
                            key={index}
                            className={`${cls["filter-list__item"]} ${String(item.id) === selectedId ? cls.selected__option : ""}`}
                            onClick={() => handleSelect(String(item.id))}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomFilterSelect;
